import {
  createAmount,
} from '@dapi/sdk/spec';
import {
  taxTemplate,
} from './mock-tax';

export const cancelAndRefundOrderMockEligibleToRefund = {
  warnings: [
    {
      code: '39469',
      title: 'SERVICES NOT REFUNDED',
      detail: 'Services have been cancelled'
    }
  ],
  data: {
    orderId: 'Q3EAEY',
    refundOptions: [
      {
        travelDocumentId: '1172457148333',
        documentType: 'eticket',
        travelerIds: [
          'PT1'
        ],
        status: 'refunded',
        refundAmounts: {
          base: {
            value: 12_593,
            currencyCode: 'SEK'
          },
          totalTaxes: {
            value: 1768,
            currencyCode: 'SEK'
          },
          total: {
            value: 14_361,
            currencyCode: 'SEK'
          }
        }
      },
      {
        travelDocumentId: '1172457148334',
        documentType: 'eticket',
        travelerIds: [
          'PT2'
        ],
        status: 'refunded',
        refundAmounts: {
          base: {
            value: 12_593,
            currencyCode: 'SEK'
          },
          totalTaxes: {
            value: 1768,
            currencyCode: 'SEK'
          },
          total: {
            value: 14_361,
            currencyCode: 'SEK'
          }
        }
      },
      {
        travelDocumentId: '1172457148335',
        documentType: 'eticket',
        travelerIds: [
          'PT3'
        ],
        status: 'refunded',
        refundAmounts: {
          base: {
            value: 9445,
            currencyCode: 'SEK'
          },
          totalTaxes: {
            value: 1768,
            currencyCode: 'SEK'
          },
          total: {
            value: 11_213,
            currencyCode: 'SEK'
          }
        }
      }
    ]
  },
  dictionaries: {
    currency: {
      SEK: {
        name: 'SWEDISH KRONA',
        decimalPlaces: 0
      }
    }
  }
};

export const cancelAndRefundOrderMockEligibleToRefundOnVoucher = {
  data: {
    orderId: 'ABC123',
    refundOptions: [
      {
        travelDocumentId: 1_722_400_059_161,
        documentType: 'eticket',
        travelerIds: [
          'PT2'
        ],
        status: 'refunded',
        refundAmounts: {
          base: {
            value: 18_300,
            currencyCode: 'EUR'
          },
          taxes: [
            {
              value: 1184,
              currencyCode: 'EUR',
              code: 'DE'
            },
            {
              value: 1520,
              currencyCode: 'EUR',
              code: 'OY'
            },
            {
              value: 3367,
              currencyCode: 'EUR',
              code: 'RD'
            },
            {
              value: 4800,
              currencyCode: 'EUR',
              code: 'YQ'
            }
          ],
          totalTaxes: {
            value: 10_871,
            currencyCode: 'EUR'
          },
          total: {
            value: 29_171,
            currencyCode: 'EUR'
          }
        },
        paidAmount: {
          base: {
            value: 18_300,
            currencyCode: 'EUR'
          },
          taxes: [
            {
              value: 1184,
              currencyCode: 'EUR',
              code: 'DE'
            },
            {
              value: 1520,
              currencyCode: 'EUR',
              code: 'OY'
            },
            {
              value: 3367,
              currencyCode: 'EUR',
              code: 'RD'
            },
            {
              value: 4800,
              currencyCode: 'EUR',
              code: 'YQ'
            }
          ]
        },
        usedAmount: {
          base: {
            value: 0,
            currencyCode: 'EUR'
          }
        },
        paymentDetails: [
          {
            paymentMethod: {
              id: '1234560035566827',
              paymentType: 'VoucherPayment'
            },
            amount: {
              value: 29_179,
              currencyCode: 'EUR'
            }
          }
        ]
      }
    ]
  },
  dictionaries: {
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    }
  }
};

export const cancelAndRefundOrderMockEligibleToRefundWithServices = {
  warnings: [
    {
      code: 39_469,
      title: 'SERVICES NOT REFUNDED',
      detail: 'Services have been cancelled'
    }
  ],
  data: {
    orderId: 'K26CZX',
    refundOptions: [
      {
        travelDocumentId: 1_722_400_159_180,
        documentType: 'eticket',
        travelerIds: [
          'PT2'
        ],
        status: 'refunded',
        refundAmounts: {
          base: {
            value: 20_000,
            currencyCode: 'EUR'
          },
          totalTaxes: {
            value: 6110,
            currencyCode: 'EUR'
          },
          total: {
            value: 16_110,
            currencyCode: 'EUR'
          }
        },
        penalty: {
          value: 10_000,
          currencyCode: 'EUR'
        }
      }
    ]
  },
  dictionaries: {
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    }
  }
};

export const cancelAndRefundOrderMockEligibleToRefundWithoutServices = {
  data: {
    orderId: 'Q3EAEY',
    refundOptions: [
      {
        travelDocumentId: '1172457148333',
        documentType: 'eticket',
        travelerIds: [
          'PT1'
        ],
        status: 'refunded',
        refundAmounts: {
          base: {
            value: 12_593,
            currencyCode: 'SEK'
          },
          totalTaxes: {
            value: 1768,
            currencyCode: 'SEK'
          },
          total: {
            value: 14_361,
            currencyCode: 'SEK'
          }
        }
      },
      {
        travelDocumentId: '1172457148334',
        documentType: 'eticket',
        travelerIds: [
          'PT2'
        ],
        status: 'refunded',
        refundAmounts: {
          base: {
            value: 12_593,
            currencyCode: 'SEK'
          },
          totalTaxes: {
            value: 1768,
            currencyCode: 'SEK'
          },
          total: {
            value: 14_361,
            currencyCode: 'SEK'
          }
        }
      },
      {
        travelDocumentId: '1172457148335',
        documentType: 'eticket',
        travelerIds: [
          'PT3'
        ],
        status: 'refunded',
        refundAmounts: {
          base: {
            value: 9445,
            currencyCode: 'SEK'
          },
          totalTaxes: {
            value: 1768,
            currencyCode: 'SEK'
          },
          total: {
            value: 11_213,
            currencyCode: 'SEK'
          }
        }
      }
    ]
  },
  dictionaries: {
    currency: {
      SEK: {
        name: 'SWEDISH KRONA',
        decimalPlaces: 0
      }
    }
  }
};

export const cancelAndRefundOrderMockEligibleToRefundWithInsurances = {
  warnings: [
    {
      code: 39_471,
      title: 'INSURANCES NOT REFUNDED',
      detail: 'insurances have been cancelled'
    }
  ],
  data: {
    orderId: 'K26CZX',
    refundOptions: [
      {
        travelDocumentId: 1_722_400_159_180,
        documentType: 'eticket',
        travelerIds: [
          'PT2'
        ],
        status: 'refunded',
        refundAmounts: {
          base: {
            value: 20_000,
            currencyCode: 'EUR'
          },
          totalTaxes: {
            value: 6110,
            currencyCode: 'EUR'
          },
          total: {
            value: 16_110,
            currencyCode: 'EUR'
          }
        },
        penalty: {
          value: 10_000,
          currencyCode: 'EUR'
        }
      }
    ]
  },
  dictionaries: {
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    }
  }
};

export const cancelAndRefundOrderMockEligibleToRefundWithInsurancesAndServices = {
  warnings: [
    {
      code: 39_469,
      title: 'SERVICES NOT REFUNDED',
      detail: 'Services have been cancelled'
    },
    {
      code: 39_469,
      title: 'INSURANCES NOT REFUNDED',
      detail: 'InSurances have been cancelled'
    }
  ],
  data: {
    orderId: 'K26CZX',
    refundOptions: [
      {
        travelDocumentId: 1_722_400_159_180,
        documentType: 'eticket',
        travelerIds: [
          'PT2'
        ],
        status: 'refunded',
        refundAmounts: {
          base: {
            value: 20_000,
            currencyCode: 'EUR'
          },
          totalTaxes: {
            value: 6110,
            currencyCode: 'EUR'
          },
          total: {
            value: 16_110,
            currencyCode: 'EUR'
          }
        },
        penalty: {
          value: 10_000,
          currencyCode: 'EUR'
        }
      }
    ]
  },
  dictionaries: {
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    }
  }
};

export const cancelAndRefundOrderMockOutboundDisruptedManuallyRefundable = {
  warnings: [
    {
      code: '39469',
      title: 'SERVICES NOT REFUNDED',
      detail: 'Services have been cancelled'
    }
  ],
  data: {
    orderId: 'TBEVQ7',
    refundOptions: [
      {
        travelDocumentId: '1052467303580',
        documentType: 'eticket',
        travelerIds: [
          'PT1'
        ],
        status: 'refunded',
        refundAmounts: {
          base: {
            value: 48_400,
            currencyCode: 'EUR'
          },
          totalTaxes: {
            value: 17_548,
            currencyCode: 'EUR'
          },
          total: {
            value: 65_948,
            currencyCode: 'EUR'
          }
        }
      },
      {
        travelDocumentId: '1052467303579',
        documentType: 'eticket',
        travelerIds: [
          'PT2'
        ],
        status: 'refunded',
        refundAmounts: {
          base: {
            value: 36_300,
            currencyCode: 'EUR'
          },
          totalTaxes: {
            value: 16_338,
            currencyCode: 'EUR'
          },
          total: {
            value: 52_638,
            currencyCode: 'EUR'
          }
        }
      }
    ]
  },
  dictionaries: {
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    }
  }
};

export const cancelAndRefundOrderMockEligibleToRefundWithServicesAndDetailledAmounts = {
  warnings: [
    {
      code: 39_469,
      title: 'SERVICES NOT REFUNDED',
      detail: 'Services have been cancelled'
    }
  ],
  data: {
    orderId: 'OQJTFY',
    refundOptions: [
      {
        travelDocumentId: 2_202_462_234_880,
        documentType: 'eticket',
        travelerIds: [
          'PT1'
        ],
        status: 'refundable',
        refundAmounts: {
          base: {
            value: 0,
            currencyCode: 'EUR'
          },
          taxes: [
            {
              value: 1182,
              currencyCode: 'EUR',
              code: 'DE'
            },
            {
              value: 1533,
              currencyCode: 'EUR',
              code: 'OY'
            },
            {
              value: 2673,
              currencyCode: 'EUR',
              code: 'RD'
            }
          ],
          totalTaxes: {
            value: 5388,
            currencyCode: 'EUR'
          },
          total: {
            value: 5388,
            currencyCode: 'EUR'
          }
        },
        paidAmount: {
          base: {
            value: 16_000,
            currencyCode: 'EUR'
          },
          taxes: [
            {
              value: 1184,
              currencyCode: 'EUR',
              code: 'DE'
            },
            {
              value: 1533,
              currencyCode: 'EUR',
              code: 'OY'
            },
            {
              value: 3220,
              currencyCode: 'EUR',
              code: 'RD'
            },
            {
              value: 4500,
              currencyCode: 'EUR',
              code: 'YQ'
            },
            {
              value: 1182,
              currencyCode: 'EUR',
              code: 'DE'
            },
            {
              value: 1533,
              currencyCode: 'EUR',
              code: 'OY'
            },
            {
              value: 2673,
              currencyCode: 'EUR',
              code: 'RD'
            },
            {
              value: 900,
              currencyCode: 'EUR',
              code: 'YQ'
            }
          ]
        },
        usedAmount: {
          base: {
            value: 16_000,
            currencyCode: 'EUR'
          },
          taxes: [
            {
              value: 1184,
              currencyCode: 'EUR',
              code: 'DE'
            },
            {
              value: 1533,
              currencyCode: 'EUR',
              code: 'OY'
            },
            {
              value: 3220,
              currencyCode: 'EUR',
              code: 'RD'
            },
            {
              value: 4500,
              currencyCode: 'EUR',
              code: 'YQ'
            }
          ]
        },
        penalty: {
          value: 5000,
          currencyCode: 'EUR'
        }
      },
      {
        travelDocumentId: 2_202_462_234_881,
        documentType: 'eticket',
        travelerIds: [
          'PT2'
        ],
        status: 'refundable',
        refundAmounts: {
          base: {
            value: 0,
            currencyCode: 'EUR'
          },
          taxes: [
            {
              value: 2366,
              currencyCode: 'EUR',
              code: 'DE'
            },
            {
              value: 3066,
              currencyCode: 'EUR',
              code: 'OY'
            },
            {
              value: 5893,
              currencyCode: 'EUR',
              code: 'RD'
            }
          ],
          totalTaxes: {
            value: 11_325,
            currencyCode: 'EUR'
          },
          total: {
            value: 11_325,
            currencyCode: 'EUR'
          }
        },
        paidAmount: {
          base: {
            value: 12_000,
            currencyCode: 'EUR'
          },
          taxes: [
            {
              value: 2366,
              currencyCode: 'EUR',
              code: 'DE'
            },
            {
              value: 3066,
              currencyCode: 'EUR',
              code: 'OY'
            },
            {
              value: 5893,
              currencyCode: 'EUR',
              code: 'RD'
            },
            {
              value: 5400,
              currencyCode: 'EUR',
              code: 'YQ'
            }
          ]
        },
        usedAmount: {
          base: {
            value: 12_000,
            currencyCode: 'EUR'
          }
        },
        penalty: {
          value: 5000,
          currencyCode: 'EUR'
        }
      }
    ]
  },
  dictionaries: {
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    }
  }
};

export const cancelAndRefundOrderMockEligibleToVoluntaryRefund = {
  data: {
    orderId: 'TBEVQ7',
    refundOptions: [
      {
        travelDocumentId: 9_562_400_002_065,
        documentType: 'eticket',
        travelerIds: [
          'PT2'
        ],
        status: 'refunded',
        refundAmounts: {
          base: createAmount({
            template: {
              value: 45_700
            }
          }),
          taxes: [
            {
              ...taxTemplate,
              value: 473,
              code: 'FR'
            },
            {
              ...taxTemplate,
              value: 820,
              code: 'FR'
            },
            {
              ...taxTemplate,
              value: 1127,
              code: 'IZ'
            },
            {
              ...taxTemplate,
              value: 900,
              code: 'O4'
            },
            {
              ...taxTemplate,
              value: 637,
              code: 'QW'
            }
          ],
          totalTaxes: createAmount({
            template: {
              value: 3957
            }
          }),
          total: createAmount({
            template: {
              value: 45_057
            }
          })
        },
        paidAmount: {
          base: createAmount({
            template: {
              value: 45_700
            }
          }),
          taxes: [
            {
              ...taxTemplate,
              value: 473,
              code: 'FR'
            },
            {
              ...taxTemplate,
              value: 820,
              code: 'FR'
            },
            {
              ...taxTemplate,
              value: 1127,
              code: 'IZ'
            },
            {
              ...taxTemplate,
              value: 900,
              code: 'O4'
            },
            {
              ...taxTemplate,
              value: 637,
              code: 'QW'
            }
          ]
        },
        usedAmount: {
          base: createAmount({
            template: {
              value: 0
            }
          })
        },
        penalty: createAmount({
          template: {
            value: 4600
          }
        })
      }
    ]
  },
  dictionaries: {
    currency: {
      EUR: {
        name: 'EURO',
        decimalPlaces: 2
      }
    }
  }
};
